import { render, staticRenderFns } from "./ChildComment.vue?vue&type=template&id=0fc59286&scoped=true&"
import script from "./ChildComment.vue?vue&type=script&lang=js&"
export * from "./ChildComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc59286",
  null
  
)

export default component.exports